// alert
import alert from '@drivesally/sally-ui/lib/libs/alert';

// error lib
import parseError from '@drivesally/sally-fw/lib/error/parseError';

// event HOCs
import subscriptionHOC from '@drivesally/sally-fw/lib/event/hoc/subscription.hoc.event';

// propTypes
import PropTypes from 'prop-types';

// react
import React, {Component} from 'react';

// repo attributes
import repoTypeAttribute from '../../attributes/repo_type.attribute.repo';
import repoOutcomeAttribute from '../../attributes/repo_outcome.attribute.repo';
import repoReasonAttribute from '../../attributes/repo_reason.attribute.repo';
import repoNotesAttribute from '../../attributes/repo_notes.attribute.repo';
import deactivationNotesAttribute from '../../attributes/deactivation_notes.attribute.repo';
import rentAfterBalanceIsPaidAttribute from '../../attributes/rent_after_balance_is_paid.attribute.repo';

// repo api
import updateRepoApi from '@drivesally/sally-fn/lib/repo/api/update.api.repo';

// repo components
import RepoDetailsModal from '../../components/RepoDetailsModal/RepoDetailsModal';

// repo events
import showDetailsEvent from '../../events/showDetails.event.repo';
import updatedEvent from '../../events/updated.event.repo';

// repo preparations
import updatePrep from '../../preparations/update.preparation.repo';

class RepoDetailsContainer extends Component {
  static propTypes = {
    subscribe: PropTypes.func,
  };

  state = {
    visible: false,
    repo: null,
    saving: false,
    repo_type: repoTypeAttribute(''),
    repo_outcome: repoOutcomeAttribute(''),
    repo_reason: repoReasonAttribute(''),
    repo_notes: repoNotesAttribute(''),
    deactivation_notes: deactivationNotesAttribute(''),
    rent_after_balance_is_paid: rentAfterBalanceIsPaidAttribute('na'),
  };

  componentDidMount() {
    this.props.subscribe(showDetailsEvent.subscribe(this.showDetails));
  }

  showDetails = (repo) => {
    this.setState({
      visible: true,
      repo,
      repo_type: repoTypeAttribute(repo?.repo_type || ''),
      repo_outcome: repoOutcomeAttribute(repo?.repo_outcome || ''),
      repo_reason: repoReasonAttribute(repo?.repo_reason || ''),
      repo_notes: repoNotesAttribute(repo?.repo_notes || ''),
      deactivation_notes: deactivationNotesAttribute(repo?.deactivation_notes || ''),
      rent_after_balance_is_paid: rentAfterBalanceIsPaidAttribute(
        repo?.rent_after_balance_is_paid === true ? 'yes' : repo?.rent_after_balance_is_paid === false ? 'no' : 'na',
      ),
    });
  };

  hideDetails = () => {
    if (this.state.saving) return;
    this.setState({visible: false, repo: null});
  };

  change = (value, key) => {
    if (this.state.saving) return;
    
    if (key === 'repo_outcome' && value.value() === 'contract_termination_reactivation') {
      this.setState({repo_type: repoTypeAttribute('driver_returned')});
    } else if (key === 'repo_outcome' && value.value() !== 'contract_termination_no_reactivation' && value.value() !== 'contract_termination_reversal') {
      this.setState({repo_type: repoTypeAttribute('no_repo')});
    }

    this.setState({[key]: value}); 
    
  };

  save = async () => {
    const {repo, repo_type, repo_outcome, repo_reason, repo_notes, deactivation_notes, rent_after_balance_is_paid, saving} = this.state;
    if (saving) return;
    this.setState({saving: true});

    try {
      const preparedRepo = await updatePrep({
        repo_type,
        repo_outcome,
        repo_reason,
        repo_notes,
        deactivation_notes,
        rent_after_balance_is_paid,
      });
      const updatedRepo = await updateRepoApi(repo.id, preparedRepo);
      updatedEvent.publish(updatedRepo);
      alert.success('Repo updated');
      this.setState({saving: false, visible: false});
    } catch (error) {
      const {message} = parseError(error);
      alert.error(message);
      this.setState({saving: false});
    }
  };

  render() {
    const {
      visible,
      repo,
      repo_type,
      repo_outcome,
      repo_reason,
      saving,
      repo_notes,
      deactivation_notes,
      rent_after_balance_is_paid,
    } = this.state;
    return (
      <RepoDetailsModal
        visible={visible}
        onClose={this.hideDetails}
        onSave={this.save}
        onChange={this.change}
        saving={saving}
        repo={repo}
        repo_type={repo_type}
        repo_outcome={repo_outcome}
        repo_reason={repo_reason}
        repo_notes={repo_notes}
        deactivation_notes={deactivation_notes}
        rent_after_balance_is_paid={rent_after_balance_is_paid}
      />
    );
  }
}

export default subscriptionHOC(RepoDetailsContainer);
